import "../App.css";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import "./ThankYou";
import "./Acknowledgement";
import "./Error";
import Download from "../components/downloads/A-525DS Rev A.pdf";
import Notice from "../components/downloads/DeVilbiss_525_Manual_Update_Customer_Notification_Letter.pdf";
import { getEnv } from "../components/helpers/Config";
import { Axios } from "../axios/Axios";
import ReactGA from "react-ga";
import "react-upload-gallery/dist/style.css";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const Home = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const [formValues, setFormValues] = useState();
  //This useEffect is for google analytics
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  //This use effect checks to make sure the site is available then loads any data needed
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has("user")) {
      const user = params.get("user");
      if (user === "true") {
        setShowPage(2);
        setValidCode(false);
      }
    }
    var ip;
    //creating function to load ip address from the API
    axios({
      method: "get",
      url: "https://api.ipify.org/?format=json",
    })
      .then((response) => {
        ip = response.data.ip;

        axios({
          method: "get",
          url:
            url + "/verification/SiteAvailability?id=" + siteId + "&&ip=" + ip,
        })
          .then(async (response) => {
            if (!response.data) {
              navigate("/Construction", { replace: true });
            } else {
              if (params.has("code")) {
                const code = params.get("code");
                console.log(code);
                var validate = await Axios.ValidateRecord(code.toUpperCase());
                console.log(validate);
                if (validate) {
                  if (
                    validate.find(
                      (a) => a.dynamicFieldId == 67781 && a.fieldValue === "23"
                    )
                  ) {
                    setIsDisabled(true);
                  }
                  setFormValues(validate);
                  setValue("code", code.toUpperCase());
                  Axios.SaveRecord(validate);
                }
              } else {
              }
            }
          })
          .catch((response) => {
            navigate("/Error", { replace: true });
          });
      })
      .catch((response) => {
        console.log("IP address retrieval failure");
      });
  }, []);
  //This use effect resets the page to initial state when user clicks the home button in navigation
  useEffect(() => {
    if (location.state?.data) {
      setShowPage(1);
      reset();
    }
  }, [location.key]);
  let navigate = useNavigate();
  const siteId = 52;
  let url = getEnv();
  const { t, i18n } = useTranslation();
  const {
    register,
    handleSubmit,
    getValues,
    watch,
    trigger,
    setValue,
    setError,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
  });
  const validateClick = async (code) => {
    console.log(getValues());
    var isValid = await Axios.ValidateRecord(code.toUpperCase());
    console.log(isValid);
    if (isValid) {
      setFormValues(isValid);
      setForm(isValid);
      Axios.SaveRecord(isValid);
      setIsDisabled(false);
      if (
        isValid.find((a) => a.dynamicFieldId == 67781 && a.fieldValue === "23")
      ) {
        setIsDisabled(true);
        return "deactivated";
      }
      return "valid";
    } else {
      return "not valid";
    }
  };
  const setForm = (data) => {
    data.forEach((data) => {
      switch (data.dynamicFieldId) {
        case 33505:
          setValue("company", data.fieldValue);
          setreadOnlyCompany(true);
          setName(data.fieldValue);
          break;
        case 59229:
          setNumber(data.fieldValue);
          setValue("verifyCode", data.fieldValue);
          setreadOnlyCode(true);
          setExcelURL(
            "https://" +
              window.location.hostname +
              "/assets/DeVilbissFiles/" +
              data.fieldValue +
              ".xlsx"
          );
          break;
        case 67759:
          setQtyAllowed(data.fieldValue);
          break;
        case 59231:
          if (data.fieldValue === "23") {
            setIsVerified(true);
          }
          break;
        // case 67781:
        //   if (data.fieldValue === "23") {
        //     setIsDisabled(true);
        //   }
        //   break;
      }
    });
  };
  const download = async (url) => {
    var isDownload = await axios.get(url, {
      responseType: "blob",
    });
    if (isDownload) {
      const downloadURL = window.URL.createObjectURL(isDownload.data);
      const link = document.createElement("a");
      link.href = downloadURL;
      link.setAttribute("download", watchCode + ".xlsx");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };
  const onSubmit = (data) => {
    setIsSubmitting(true);
    let SFDFI = [
      {
        DynamicFieldId: 33504,
        FieldValue: data.address,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33512,
        FieldValue: data.city,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33513,
        FieldValue: data.country,
        //FieldValue: "US",
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33508,
        FieldValue: data.email,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33502,
        FieldValue: data.firstName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33503,
        FieldValue: data.lastName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33515,
        FieldValue: data.postalCode,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33507,
        FieldValue: data.phoneNumber,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33514,
        FieldValue: data.state,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      // Site Specific Fields

      {
        DynamicFieldId: 67763,
        FieldValue: data.qty,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
    ];

    if (data.address2) {
      SFDFI.push({
        DynamicFieldId: 33506,
        FieldValue: data.address2,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.verifyCode) {
      SFDFI.push({
        DynamicFieldId: 67764,
        FieldValue: data.verifyCode,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.company) {
      SFDFI.push({
        DynamicFieldId: 33505,
        FieldValue: data.company,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.confirm === "No") {
      SFDFI.push({
        DynamicFieldId: 60390,
        FieldValue: data.attentionTo,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    } else {
      SFDFI.push({
        DynamicFieldId: 60390,
        FieldValue: data.firstName + " " + data.lastName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    console.log(data);

    var SimpleSuperFormDTO = {
      FormInstances: {
        DefinitionId: 502,
        CompanyId: 104,
        CreatedBy: 803,
        CreatedFor: 803,
        WorkTypeItemId: 3522,
        WorkFlowOverallStatusId: 1,
        WorkflowId: 1,
        Source: 3,
        InstanceID: 0,
      },
      DynamicFieldslist: SFDFI,
    };
    SimpleSuperFormDTO.FormInstances.CreatedDate = new Date();
    console.log(SimpleSuperFormDTO);
    axios({
      method: "post",
      url: url + "/SuperForm/SaveSimpleSuperForm",
      data: SimpleSuperFormDTO,
    })
      .then((response) => {
        console.log("success");
        setOrderPage(0);
        setIsSubmitting(false);
        setInstance(response.data.formInstances.instanceId);
        setSaveSuccess(true);
        Axios.orderEmail(data, response.data.formInstances.instanceId);
      })
      .catch((response) => {
        setIsSubmitting(false);
        console.log("fail");
        navigate("/Error", { replace: true });
      });
  };
  const [showPage, setShowPage] = useState(1);
  const [validCode, setValidCode] = useState(true);
  const [excelURL, setExcelURL] = useState();
  const [name, setName] = useState();
  const [number, setNumber] = useState();
  const [qtyAllowed, setQtyAllowed] = useState(500);
  const [orderPage, setOrderPage] = useState(0);
  const [readOnlyCode, setreadOnlyCode] = useState(false);
  const [readOnlyCompany, setreadOnlyCompany] = useState(false);
  const [wrongButton, setWrongButton] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [instance, setInstance] = useState();
  const [isVerified, setIsVerified] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isVerifiedError, setIsVerifiedError] = useState(false);

  const watchConfirm = watch("confirm", null); // you can supply default value as second argument
  const watchCode = watch("code", null); // you can supply default value as second argument

  return (
    <div>
      <bootstrap.Form onSubmit={handleSubmit(onSubmit)}>
        <bootstrap.Container fluid>
          {/* Start step 1 */}
          {showPage === 1 && (
            <div className="setup-content" id="step1">
              <bootstrap.Row>
                <bootstrap.Col>
                  <h2>{t("step1.header1")}</h2>
                  <p className="lead py-1">{t("step1.textA")}</p>
                  <p className="lead py-1">
                    {t("step1.textB")}{" "}
                    <a
                      className="lead"
                      href={Notice}
                      target="_blank"
                      return
                      false
                    >
                      {t("step1.textB1")}
                    </a>{" "}
                    {t("step1.textB2")}{" "}
                  </p>
                  <p className="lead py-1">{t("step1.textC")}</p>
                  <p className="lead py-1">{t("step1.textD")}</p>
                  <p className="lead py-1">
                    <span className="lead fw-bold fst-italic ">
                      {t("step1.textD1")}
                    </span>
                    <span className="lead fst-italic ">
                      {t("step1.textD1A")}
                    </span>
                  </p>
                  <p className="lead fw-bold py-1">{t("step1.textE")}</p>
                  <p className="lead py-1">{t("step1.textF")}</p>
                </bootstrap.Col>
              </bootstrap.Row>

              <bootstrap.Row>
                <bootstrap.Col></bootstrap.Col>
                <bootstrap.Col>
                  {/* Verification Code */}
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="text"
                      className="text-center lead"
                      placeholder={t("layout.code")}
                      id="code"
                      {...register("code", {
                        required: false,
                        maxLength: 80,
                      })}
                    />{" "}
                  </bootstrap.InputGroup>
                  {!validCode && (
                    <bootstrap.Alert variant="danger">
                      <p className="lead text-danger text-center">
                        {t("errors.verifyError")}
                      </p>
                    </bootstrap.Alert>
                  )}
                  {isDisabled && (
                    <bootstrap.Alert variant="danger">
                      <p className="lead text-danger text-center">
                        {t("errors.disabled")}
                      </p>
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
                <bootstrap.Col></bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row>
                <bootstrap.Col>
                  <p className="fst-italic text-muted py-1">
                    {t("step1.textG")}
                  </p>
                </bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row className="text-center col align-content-lg-center pt-5">
                <bootstrap.Col>
                  <bootstrap.Button
                    className="btn btn-primary btn-lg pt-1"
                    type="button"
                    onClick={async () => {
                      var verify = await validateClick(watchCode);
                      if (verify == "not valid") {
                        setValidCode(false);
                      } else if (verify == "deactivated") {
                        setIsDisabled(true);
                      } else {
                        setValidCode(true);
                        setShowPage(2);
                      }
                    }}
                    id="verifyButton"
                  >
                    {t("buttons.verify")}
                  </bootstrap.Button>
                </bootstrap.Col>
                <bootstrap.Col>
                  <bootstrap.Button
                    className="btn btn-primary btn-lg pt-1"
                    type="button"
                    onClick={() => {
                      if (watchCode) {
                        setWrongButton(true);
                      } else {
                        console.log(watchCode);
                        setShowPage(2);
                        setValidCode(false);
                      }
                    }}
                    id="getStartedButton"
                  >
                    {t("buttons.getStarted")}
                  </bootstrap.Button>
                </bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row>
                <bootstrap.Col>
                  {wrongButton && (
                    <bootstrap.Alert variant="danger" className="mt-3">
                      <p className="lead text-danger text-center">
                        {t("errors.wrongButton")}
                      </p>
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
              </bootstrap.Row>
            </div>
          )}
          {/* Start step 2 */}
          {showPage === 2 && (
            <div className="setup-content" id="step1">
              <bootstrap.Container className="py-2">
                {validCode && (
                  <div>
                    <bootstrap.Row>
                      <bootstrap.Col>
                        {/* Name */}
                        <bootstrap.Form.Label htmlFor="name" className="lead">
                          <span className="fw-bold">{t("step2.2Name")}</span>{" "}
                          {name}
                        </bootstrap.Form.Label>
                      </bootstrap.Col>
                    </bootstrap.Row>
                    <bootstrap.Row>
                      <bootstrap.Col>
                        {/* Number */}
                        <bootstrap.Form.Label htmlFor="number" className="lead">
                          <span className="fw-bold">{t("step2.2Number")}</span>{" "}
                          {number}
                        </bootstrap.Form.Label>
                      </bootstrap.Col>
                    </bootstrap.Row>
                    <bootstrap.Row>
                      <bootstrap.Col>
                        <p className="lead py-1">{t("step2.2A")}</p>
                      </bootstrap.Col>
                    </bootstrap.Row>
                  </div>
                )}
                <bootstrap.Card className="mt-3">
                  <bootstrap.Card.Body>
                    <bootstrap.Row>
                      <bootstrap.Col>
                        <p className="lead fw-bold py-1">{t("step2.2B")}</p>
                      </bootstrap.Col>
                    </bootstrap.Row>
                    <bootstrap.Row className="text-center col align-content-lg-center pt-5">
                      <bootstrap.Col>
                        <a
                          className="btn btn-primary btn-lg pt-1"
                          href={Download}
                          target="_blank"
                          return
                          false
                        >
                          {t("buttons.download")}
                        </a>
                      </bootstrap.Col>
                      <bootstrap.Col>
                        <bootstrap.Button
                          className="btn btn-primary btn-lg pt-1"
                          type="button"
                          onClick={() => {
                            setOrderPage(1);
                            setSaveSuccess(false);
                          }}
                          id="orderButton"
                        >
                          {t("buttons.order")}
                        </bootstrap.Button>
                      </bootstrap.Col>
                    </bootstrap.Row>
                    <bootstrap.Row>
                      <bootstrap.Col>
                        {saveSuccess && (
                          <bootstrap.Alert variant="success" className="mt-3">
                            <p className="lead text-center">
                              {t("step5.orderA")}
                            </p>
                            <p className="lead">
                              {t("step5.orderID")} {instance}
                            </p>
                            <p className="lead">{t("step5.orderB")}</p>
                            <p className="lead">{t("step5.orderC")}</p>
                          </bootstrap.Alert>
                        )}
                      </bootstrap.Col>
                    </bootstrap.Row>
                    {/* Start step 3 */}
                    {orderPage === 1 && (
                      <div className="setup-content" id="step3">
                        {/* Gather Contact Information */}

                        <bootstrap.Row>
                          <bootstrap.Col>
                            <bootstrap.Card className="border-custom mt-3">
                              <bootstrap.Card.Header>
                                <bootstrap.Row>
                                  <bootstrap.Col>
                                    <p className="lead fw-bold py-1">
                                      {t("contactStep.text")}
                                    </p>
                                    <p className="lead py-1">
                                      {t("contactStep.textA")}
                                    </p>
                                  </bootstrap.Col>
                                </bootstrap.Row>
                              </bootstrap.Card.Header>
                              <bootstrap.Card.Body>
                                <bootstrap.Row>
                                  <bootstrap.Col lg={2}></bootstrap.Col>
                                  <bootstrap.Col className="form-group align-content-lg-center">
                                    {/* Verification Code */}

                                    <bootstrap.InputGroup className="mb-3 d-none">
                                      <bootstrap.Form.Control
                                        type="text"
                                        id="verifyCode"
                                        readOnly={readOnlyCode}
                                        {...register("verifyCode", {
                                          required: false,
                                          maxLength: 80,
                                        })}
                                      />{" "}
                                    </bootstrap.InputGroup>
                                    {/* Company */}
                                    <bootstrap.Form.Label
                                      htmlFor="company"
                                      className="lead"
                                    >
                                      {t("contactStep.company")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="text"
                                        id="company"
                                        readOnly={readOnlyCompany}
                                        {...register("company", {
                                          required: false,
                                          maxLength: 80,
                                        })}
                                      />{" "}
                                    </bootstrap.InputGroup>
                                    {/* First Name */}
                                    <bootstrap.Form.Label
                                      htmlFor="firstName"
                                      className="lead"
                                    >
                                      {t("contactStep.firstName")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="text"
                                        // placeholder={t("contactStep.firstName")}
                                        id="firstName"
                                        {...register("firstName", {
                                          required: true,
                                          maxLength: 80,
                                        })}
                                      />{" "}
                                    </bootstrap.InputGroup>
                                    {errors.firstName && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                    {/* Last Name */}
                                    <bootstrap.Form.Label
                                      htmlFor="lastName"
                                      className="lead"
                                    >
                                      {t("contactStep.lastName")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="text"
                                        //placeholder={t("contactStep.lastName")}
                                        id="lastName"
                                        {...register("lastName", {
                                          required: true,
                                          maxLength: 100,
                                        })}
                                      />
                                    </bootstrap.InputGroup>
                                    {errors.lastName && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                    {/* Email */}
                                    <bootstrap.Form.Label
                                      htmlFor="email"
                                      className="lead"
                                    >
                                      {t("contactStep.email")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="email"
                                        //placeholder={t("contactStep.email")}
                                        id="email"
                                        aria-describedby="emailtext"
                                        {...register("email", {
                                          required: true,
                                          pattern:
                                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                        })}
                                      />

                                      <bootstrap.InputGroup.Text id="emailText">
                                        @example.com
                                      </bootstrap.InputGroup.Text>
                                    </bootstrap.InputGroup>
                                    {errors.email && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                    {errors.email &&
                                      errors.email.type === "pattern" && (
                                        <bootstrap.Alert variant="danger">
                                          <p className="lead text-danger text-center">
                                            {t("errors.emailFormatError")}
                                          </p>
                                        </bootstrap.Alert>
                                      )}
                                    {/* Verify Email */}
                                    <bootstrap.Form.Label
                                      htmlFor="verifyEmail"
                                      className="lead"
                                    >
                                      {t("contactStep.verifyEmail")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="email"
                                        //placeholder={t("contactStep.verifyEmail")}
                                        id="verifyEmail"
                                        aria-describedby="verifyEmailText"
                                        {...register("verifyEmail", {
                                          required: true,
                                          pattern:
                                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                          validate: {
                                            mismatch: (value) => {
                                              const { email } = getValues();
                                              return email === value;
                                            },
                                          },
                                        })}
                                      />
                                      <bootstrap.InputGroup.Text id="verifyEmailText">
                                        @example.com
                                      </bootstrap.InputGroup.Text>
                                    </bootstrap.InputGroup>
                                    {errors.verifyEmail &&
                                      errors.verifyEmail.type ===
                                        "mismatch" && (
                                        <bootstrap.Alert variant="danger">
                                          <p className="lead text-danger text-center">
                                            {t("errors.emailMismatchError")}
                                          </p>
                                        </bootstrap.Alert>
                                      )}
                                    {errors.verifyEmail &&
                                      errors.verifyEmail.type === "pattern" && (
                                        <bootstrap.Alert variant="danger">
                                          <p className="lead text-danger text-center">
                                            {t("errors.emailFormatError")}
                                          </p>
                                        </bootstrap.Alert>
                                      )}
                                    {errors.verifyEmail && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                    {/* Phone */}
                                    <bootstrap.Form.Label
                                      htmlFor="phone"
                                      className="lead"
                                    >
                                      {t("contactStep.phone")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="tel"
                                        placeholder="XXXXXXXXXX"
                                        id="phone"
                                        {...register("phoneNumber", {
                                          required: true,
                                          maxLength: 10,
                                          pattern: /\d{10}/i,
                                        })}
                                      />
                                    </bootstrap.InputGroup>
                                    {errors.phoneNumber && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                    {errors.phoneNumber &&
                                      errors.phoneNumber.type === "pattern" && (
                                        <bootstrap.Alert variant="danger">
                                          <p className="lead text-danger text-center">
                                            {t("errors.phoneFormatError")}
                                          </p>
                                        </bootstrap.Alert>
                                      )}
                                  </bootstrap.Col>
                                  <bootstrap.Col lg={2}></bootstrap.Col>
                                </bootstrap.Row>
                                <bootstrap.Row>
                                  <bootstrap.Col lg={2}></bootstrap.Col>
                                  <bootstrap.Col className="py-1">
                                    <p className="text-center lead font-weight-bold">
                                      {t("contactStep.confirm")}
                                    </p>
                                    {/* Contact Confirm */}
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Select
                                        className="text-center"
                                        aria-label="Default select example"
                                        id="confirm"
                                        {...register("confirm", {
                                          required: true,
                                        })}
                                      >
                                        <option value="">
                                          {t("layout.pleaseSelect")}
                                        </option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                      </bootstrap.Form.Select>
                                    </bootstrap.InputGroup>
                                    {errors.confirm && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                    {/* Attention To*/}
                                    {watchConfirm === "No" && (
                                      <div>
                                        <bootstrap.Form.Label
                                          htmlFor="attentionTo"
                                          className="lead"
                                        >
                                          {t("contactStep.attentionTo")}
                                        </bootstrap.Form.Label>
                                        <bootstrap.InputGroup className="mb-3">
                                          <bootstrap.Form.Control
                                            type="text"
                                            // placeholder={t("contactStep.firstName")}
                                            id="attentionTo"
                                            {...register("attentionTo", {
                                              maxLength: 80,
                                              validate: {
                                                required: (value) =>
                                                  watchConfirm === "No" &&
                                                  value.length > 0,
                                              },
                                            })}
                                          />
                                        </bootstrap.InputGroup>
                                        {errors.attentionTo && (
                                          <bootstrap.Alert variant="danger">
                                            <p className="lead text-danger text-center">
                                              {t("errors.required")}
                                            </p>
                                          </bootstrap.Alert>
                                        )}
                                      </div>
                                    )}
                                  </bootstrap.Col>
                                  <bootstrap.Col lg={2}></bootstrap.Col>
                                </bootstrap.Row>
                                <div className="text-center pt-1">
                                  <bootstrap.Button
                                    className="btn btn-primary btn-lg pt-1"
                                    type="button"
                                    onClick={async () => {
                                      const result = await trigger([
                                        "firstName",
                                        "lastName",
                                        "email",
                                        "verifyEmail",
                                        "phoneNumber",
                                        "confirm",
                                        "attentionTo",
                                      ]);
                                      if (result) {
                                        setOrderPage(2);
                                      }
                                    }}
                                    id="step3Button"
                                  >
                                    {t("buttons.next")}
                                  </bootstrap.Button>
                                </div>
                              </bootstrap.Card.Body>
                            </bootstrap.Card>
                          </bootstrap.Col>
                        </bootstrap.Row>
                      </div>
                    )}
                    {/* Start step 4 */}
                    {orderPage === 2 && (
                      <div className="setup-content" id="step4">
                        {/* Gather Contact Information */}

                        <bootstrap.Row>
                          <bootstrap.Col>
                            <bootstrap.Card className="border-custom mt-3">
                              <bootstrap.Card.Header>
                                <bootstrap.Row>
                                  <bootstrap.Col>
                                    <p className="lead pt-3 pb-1">
                                      {t("addressStep.quantity")}
                                    </p>
                                  </bootstrap.Col>
                                </bootstrap.Row>
                                <bootstrap.Row>
                                  <bootstrap.Col></bootstrap.Col>
                                  <bootstrap.Col>
                                    {/* Qty */}
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="number"
                                        id="qty"
                                        {...register("qty", {
                                          required: true,
                                          validate: {
                                            belowMinimum: (value) =>
                                              parseFloat(value) > 0,
                                            exceedMaximum: (value) =>
                                              parseFloat(value) <=
                                              parseFloat(qtyAllowed),
                                          },
                                        })}
                                      />
                                    </bootstrap.InputGroup>
                                    {errors.qty &&
                                      errors.qty.type === "belowMinimum" && (
                                        <bootstrap.Alert
                                          className=""
                                          variant="danger"
                                        >
                                          <p className="lead text-danger text-center">
                                            {t("errors.required")}
                                          </p>
                                        </bootstrap.Alert>
                                      )}
                                    {errors.qty &&
                                      errors.qty.type === "exceedMaximum" && (
                                        <bootstrap.Alert
                                          className=""
                                          variant="danger"
                                        >
                                          <p className="lead text-danger text-center">
                                            {t("errors.maxError")}
                                          </p>
                                        </bootstrap.Alert>
                                      )}
                                  </bootstrap.Col>
                                  <bootstrap.Col></bootstrap.Col>
                                </bootstrap.Row>
                              </bootstrap.Card.Header>
                              <bootstrap.Card.Body>
                                <bootstrap.Row>
                                  <bootstrap.Col>
                                    <p className="lead fw-bold py-1">
                                      {t("addressStep.header")}
                                    </p>
                                    <p className="lead py-1">
                                      {t("addressStep.subHeader")}
                                    </p>
                                  </bootstrap.Col>
                                </bootstrap.Row>
                                <bootstrap.Row>
                                  <bootstrap.Col lg={2}></bootstrap.Col>
                                  <bootstrap.Col className="form-group align-content-lg-center">
                                    {/* Adress Line 1 */}
                                    <bootstrap.Form.Label
                                      htmlFor="address"
                                      className="lead"
                                    >
                                      {t("addressStep.address1")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="text"
                                        id="address"
                                        {...register("address", {
                                          required: true,
                                        })}
                                      />
                                    </bootstrap.InputGroup>
                                    {errors.address && (
                                      <bootstrap.Alert
                                        className=""
                                        variant="danger"
                                      >
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                    {/* Address 2 */}
                                    <bootstrap.Form.Label
                                      htmlFor="address2"
                                      className="lead"
                                    >
                                      {t("addressStep.address2")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="text"
                                        //placeholder={t("contactStep.lastName")}
                                        id="address2"
                                        {...register("address2", {})}
                                      />
                                    </bootstrap.InputGroup>
                                    {errors.address2 && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                    {/* City */}
                                    <bootstrap.Form.Label
                                      htmlFor="city"
                                      className="lead"
                                    >
                                      {t("addressStep.city")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="text"
                                        //placeholder={t("contactStep.email")}
                                        id="city"
                                        {...register("city", {
                                          required: true,
                                        })}
                                      />
                                    </bootstrap.InputGroup>
                                    {errors.city && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                    {/* Country */}
                                    <bootstrap.Form.Label
                                      htmlFor="country"
                                      className="lead"
                                    >
                                      {t("addressStep.country")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Select
                                        size="lg"
                                        className="text-center"
                                        //aria-label="Default select example"
                                        id="country"
                                        {...register("country", {
                                          required: true,
                                        })}
                                      >
                                        <option value="">
                                          {t("layout.pleaseSelect")}
                                        </option>
                                        <option value="US">
                                          United States
                                        </option>
                                        <option value="CA">Canada</option>
                                      </bootstrap.Form.Select>
                                    </bootstrap.InputGroup>
                                    {errors.country && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                    {/* State */}
                                    <bootstrap.Form.Label
                                      htmlFor="state"
                                      className="lead"
                                    >
                                      {t("addressStep.state")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        size="lg"
                                        className="lead"
                                        aria-label="Default State Label"
                                        id="state"
                                        {...register("state", {
                                          required: true,
                                        })}
                                      ></bootstrap.Form.Control>
                                    </bootstrap.InputGroup>
                                    {errors.state && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}

                                    {/* Postal */}
                                    <bootstrap.Form.Label
                                      htmlFor="postal"
                                      className="lead"
                                    >
                                      {t("addressStep.postalCode")}
                                    </bootstrap.Form.Label>
                                    <bootstrap.InputGroup className="mb-3">
                                      <bootstrap.Form.Control
                                        type="text"
                                        //placeholder="XXXXXXXXXX"
                                        id="postal"
                                        {...register("postalCode", {
                                          required: true,
                                          min: 5,
                                          // pattern:
                                          //   /\d{5}(-\d{4})?/i |
                                          //   /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ -]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i,
                                        })}
                                      />
                                    </bootstrap.InputGroup>
                                    {errors.postalCode && (
                                      <bootstrap.Alert variant="danger">
                                        <p className="lead text-danger text-center">
                                          {t("errors.required")}
                                        </p>
                                      </bootstrap.Alert>
                                    )}
                                  </bootstrap.Col>
                                  <bootstrap.Col lg={2}></bootstrap.Col>
                                </bootstrap.Row>
                                <bootstrap.Row className="pt-2">
                                  {!isSubmitting && (
                                    <bootstrap.Button
                                      className="btn btn-primary btn-lg pt-1 justify-content-center"
                                      type="submit"
                                      id="SubmitButton"
                                    >
                                      Submit
                                    </bootstrap.Button>
                                  )}
                                  {isSubmitting && (
                                    <bootstrap.Button
                                      className="btn btn-primary btn-lg pt-1 justify-content-center"
                                      variant="primary"
                                      disabled={true}
                                    >
                                      <bootstrap.Spinner
                                        as="span"
                                        animation="border"
                                        variant="status"
                                        aria-hidden="true"
                                      ></bootstrap.Spinner>
                                    </bootstrap.Button>
                                  )}
                                </bootstrap.Row>
                              </bootstrap.Card.Body>
                            </bootstrap.Card>
                          </bootstrap.Col>
                        </bootstrap.Row>
                      </div>
                    )}
                  </bootstrap.Card.Body>
                </bootstrap.Card>

                {validCode && (
                  <div>
                    <bootstrap.Card className="mt-3">
                      <bootstrap.Card.Body>
                        <bootstrap.Row>
                          <bootstrap.Col>
                            <p className="lead fw-bold pt-3">{t("step2.2C")}</p>
                            <p className="lead py-1">{t("step2.2D")}</p>
                          </bootstrap.Col>
                        </bootstrap.Row>
                        <bootstrap.Row className="text-center col align-content-lg-center pt-5">
                          <bootstrap.Col></bootstrap.Col>
                          <bootstrap.Col>
                            <bootstrap.Button
                              className="btn btn-primary btn-lg pt-1"
                              type="button"
                              onClick={() => {
                                download(excelURL);
                              }}
                              id="serialButton"
                            >
                              {t("buttons.serial")}
                            </bootstrap.Button>
                          </bootstrap.Col>
                          <bootstrap.Col></bootstrap.Col>
                        </bootstrap.Row>
                      </bootstrap.Card.Body>
                    </bootstrap.Card>
                    <bootstrap.Card className="mt-3">
                      <bootstrap.Card.Body>
                        <bootstrap.Row>
                          <bootstrap.Col>
                            <p className="lead fw-bold pt-3">{t("step2.2E")}</p>
                            <ul>
                              <li className="lead py-1">{t("step2.2F")}</li>
                              <li className="lead py-1">{t("step2.2G")}</li>
                              <li className="lead py-1">{t("step2.2H")}</li>
                            </ul>
                            {/* <bootstrap.Alert variant="info">
                              <p className="lead text-center">
                                {t("step2.formComing")}
                              </p>
                            </bootstrap.Alert> */}
                          </bootstrap.Col>
                        </bootstrap.Row>
                        <bootstrap.Row className="text-center pt-1">
                          <bootstrap.Col></bootstrap.Col>
                          <bootstrap.Col>
                            <bootstrap.Button
                              className="btn btn-primary btn-lg pt-1"
                              type="button"
                              //disabled={true}
                              onClick={() => {
                                if (!isVerified) {
                                  reset();
                                  navigate("/Acknowledgement", {
                                    state: {
                                      values: formValues,
                                    },
                                    replace: true,
                                  });
                                } else {
                                  setIsVerifiedError(true);
                                }
                              }}
                              id="acknowledgeButton"
                            >
                              {t("buttons.form")}
                            </bootstrap.Button>
                          </bootstrap.Col>
                          <bootstrap.Col></bootstrap.Col>
                        </bootstrap.Row>
                        <bootstrap.Row className="pt-2">
                          <bootstrap.Col>
                            {isVerifiedError && (
                              <bootstrap.Alert variant="danger">
                                <p className="lead text-danger text-center">
                                  {t("errors.verified")}
                                </p>
                              </bootstrap.Alert>
                            )}
                          </bootstrap.Col>
                        </bootstrap.Row>
                      </bootstrap.Card.Body>
                    </bootstrap.Card>
                  </div>
                )}
              </bootstrap.Container>
            </div>
          )}
        </bootstrap.Container>
      </bootstrap.Form>
    </div>
  );
};
